import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

/**
 * Auth Slice - Global User Identity
 *
 * This slice stores the authenticated user's internal ID.
 * Unlike component-scoped state, this persists across navigation
 * and is available to all middleware and reducers.
 *
 * This is the SINGLE SOURCE OF TRUTH for "who is the current user".
 */

interface AuthState {
  userId: number | null;
}

const initialState: AuthState = {
  userId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthUserId: (state, action: PayloadAction<number | null>) => {
      state.userId = action.payload;
    },
    clearAuth: (state) => {
      state.userId = null;
    },
  },
});

export const { setAuthUserId, clearAuth } = authSlice.actions;

// Selectors
export const selectAuthUserId = (state: RootState) => state.auth.userId;

export default authSlice.reducer;
